/**
 * Shared financial transaction category list — replaces 3 independently
 * duplicated copies (FinancialCategoryRules.js, FinancialStagingArea.js,
 * FinancialTransactions.js) that had to be kept in sync by hand.
 *
 * These are real, business-specific accounting categories (including owner
 * equity accounts) — not renamed or genericized here, since these exact
 * strings are matched against live transaction records. A future
 * multi-tenant setup should move this to a DB-backed lookup table (the same
 * pattern config_master.py already uses for skill levels / age categories)
 * so each business can define its own chart of accounts without a code
 * change; consolidating to one file is the safe intermediate step that
 * doesn't touch existing data.
 */
export const ALL_CATEGORIES = [
  "Bank Charges", "Insurance", "Stripe", "Tournament",
  "Misc - Cricket / Baseball /Soccer", "Vending Machine", "Point of Sale",
  "Merchandise Purchase", "Salaries - Gusto W2 & 1099", "License & Fees",
  "Office Supplies & Stationary", "Business Travel", "Marketing", "Repairs",
  "Legal & Professional", "Miscellaneous", "Utilities", "Meals & Entertainment",
  "Rent", "Tax", "Coach Accommodation",
  "Equity - Padmanaban Karvannan", "Equity - Sankar Kalaiaperumal",
  "Equity - Purush Raja", "Equity - Bala Ganeshan",
  "Equity - Renga Ramasamy", "Equity - Baskar Arokiasamy",
];
